(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('FlyerDetailsController', FlyerDetailsController);

    /** @ngInject */
    function FlyerDetailsController($uibModalInstance, $window, $translate, $scope, FlyersService, HubFlyersService,
                                    flyerId, isHubContext, isImmoContext, menuActions, quickActions,
                                    flyersConstants, systemConstants) {
        var vm = this;
        vm.defaultDetailItemsState = flyersConstants.FLYER_DETAIL_ITEMS_STATE.VARIATIONS;
        vm.flyerDetailModalBodyId = 'flyerDetailModalBody';
        vm.flyerDetailDescriptionId = 'flyerDetailDescription';
        vm.flyerDetailItemsId = 'flyerDetailItems';
        vm.emptyListImage = 'https://showkase-prod.s3.sa-east-1.amazonaws.com/assets/empty-publics-list-image.svg';
        vm.flyerId = flyerId;
        vm.flyer = undefined;
        vm.isLoading = false;
        vm.isHubContext = isHubContext;
        vm.isImmoContext = isImmoContext;
        vm.flyerType = getFlyerType();
        vm.menuActions = menuActions;
        vm.quickActions = configureQuickActions();
        vm.detailItemsState = vm.defaultDetailItemsState;
        vm.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
        vm.isDetailItemsVisible = false;
        vm.detailItemsVisibilityThreshold = 0.3; // Ativa se pelo menos 30% do elemento estiver visível

        vm.ok = closeModal;
        vm.close = closeModal;
        vm.loadFlyer = loadFlyer;
        vm.getTranslateKey = getContextTranslateKey;
        vm.modalBackToTop = modalBackToTop;

        vm.$onInit = init;
        $uibModalInstance.rendered.then(postRender);

        function init() {
            vm.loadFlyer();
        }

        function postRender() {
            vm.flyerDetailModalBody = document.getElementById(vm.flyerDetailModalBodyId);
            waitForElement('#' + vm.flyerDetailItemsId, vm.flyerDetailModalBody)
                .then(function (element) {
                    var observer = new IntersectionObserver(checkDetailItemsVisibility, {
                        root: vm.flyerDetailModalBody,
                        threshold: vm.detailItemsVisibilityThreshold
                    });

                    if (element) {
                        observer.observe(element);
                    }
                });
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }

        function modalBackToTop() {
            document.getElementById(vm.flyerDetailDescriptionId).scrollIntoView({behavior: 'smooth'});
        }

        function loadFlyer() {
            vm.isLoading = true;
            if (vm.isHubContext) {
                HubFlyersService.getFlyer(vm.flyerId).then(successResponse, errorResponse);
            } else {
                FlyersService.getFlyer(vm.flyerId).then(successResponse, errorResponse);
            }

            function successResponse(response) {
                vm.flyer = response.data;
                vm.isLoading = false;
            }

            function errorResponse() {
                vm.flyer = null;
                vm.isLoading = false;
            }
        }

        function getFlyerType() {
            return vm.isImmoContext ?
                $translate.instant('flyers.detail-modal.real-estate') :
                $translate.instant('flyers.detail-modal.product');
        }

        function getContextTranslateKey (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey);
        }

        function configureQuickActions() {
            var modalQuickActions = angular.copy(quickActions);

            var picturesActionName = 'PICTURES';
            modalQuickActions.unshift({
                name: picturesActionName,
                icon: "icon-ksc-image-light-1",
                label: 'flyers.actions.pictures',
                method: function () {
                    document.getElementById(vm.flyerDetailItemsId).scrollIntoView({behavior: 'smooth'});
                    vm.detailItemsState = flyersConstants.FLYER_DETAIL_ITEMS_STATE.PICTURES;
                }
            });

            var variationsActionName = 'VARIATIONS';
            modalQuickActions.unshift({
                name: variationsActionName,
                icon: "fa fa-list",
                label: getContextTranslateKey('flyers.actions.variations'),
                elementClass: 'visible-xs',
                method: function () {
                    document.getElementById(vm.flyerDetailItemsId).scrollIntoView({behavior: 'smooth'});
                    vm.detailItemsState = flyersConstants.FLYER_DETAIL_ITEMS_STATE.VARIATIONS;
                }
            });

            return modalQuickActions;
        }

        function checkDetailItemsVisibility(entries) {
            entries.forEach(function(entry) {
                $scope.$apply(function () {
                    vm.isDetailItemsVisible = entry.isIntersecting;
                });
            });
        }
    }
})();
